import {
  ELEMENT_ATTRIBUTE_GROUP,
  ELEMENT_GROUPS
} from '../../../../AppDesigner/Elements';

const fields = {
  group: ELEMENT_GROUPS.TEXT,
  name: 'FileUploader',
  label: 'File Uploader',
  icon: 'DocumentTextIcon',
  description: 'Upload images or files from within a Page',
  properties: [
    {
      label: 'Storage Path',
      name: 'storagePath',
      editor: 'textbox',
      readonly: false,
      description:
        'The path in firebase storage to upload the file to. This can contain placeholders in the form {{it.something.field}}',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Success Action Sequence Id',
      name: 'successActionSequenceId',
      editor: 'textbox',
      readonly: false,
      description:
        'The ID of an action sequence to run if the file upload succeeds. The action sequence can get hold of the uploaded url from the local store based on the Local Store Key Name you use.',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Accepted File Types',
      name: 'fileTypes',
      editor: 'textbox',
      default: 'text/csv',
      readonly: false,
      description:
        'A comma separated list of file times i.e. text/csv,image/png,image/jpeg,image/gif. Here is an exhaustive list image/png, image/jpeg, image/gif, image/bmp, image/webp, image/svg+xml, image/tiff, audio/mpeg, audio/wav, audio/ogg, audio/mp3, audio/aac, audio/flac, video/mp4, video/x-msvideo, video/x-ms-wmv, video/quicktime, video/webm, video/mpeg, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, text/plain, text/csv, application/rtf, application/zip, application/x-rar-compressed, application/x-7z-compressed, application/x-tar, application/gzip, text/javascript, application/json, application/xml, text/css, text/html, application/x-sh, text/x-python, text/x-java-source, application/x-httpd-php',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Accepted File Extensions',
      name: 'fileExtensions',
      editor: 'textbox',
      default: '.csv',
      readonly: false,
      description:
        'A comma separated list of file times i.e .png, .jpg, .jpeg, .gif, .bmp, .webp, .svg, .tiff, .tif, .mp3, .wav, .ogg, .aac, .flac, .mp4, .avi, .wmv, .mov, .webm, .mpeg, .mpg, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt, .csv, .rtf, .zip, .rar, .7z, .tar, .gz, .js, .json, .xml, .css, .html, .sh, .py, .java, .php',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Instructions',
      name: 'instructions',
      editor: 'textbox',
      default: 'Please drag and drop a file below to upload.',
      readonly: false,
      description:
        'The instructions that will appear above the file uploader box',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Local Store Result Key',
      name: 'localStoreKeyName',
      editor: 'textbox',
      default: 'fileUploader',
      readonly: false,
      description:
        'A key name that will be updated with the success or failure information of the file upload.',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Local Store Modal Key',
      name: 'localStoreModalKeyName',
      editor: 'textbox',
      default: 'fileUploader',
      readonly: false,
      description:
        'A key name that will be will be removed from the store when the OK or cancel button is clicked. This can be used to control a dialog.',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    }
  ]
};

export default fields;
